import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import { memo } from 'react';

var _templateObject;
var StyledLabel = styled('label')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n  position: relative;\n  user-select: none;\n  min-height: 1rem;\n  z-index: 1;\n  margin-right: ", ";\n\n  height: ", ";\n  width: ", ";\n"])), function (_ref) {
  var hideLabel = _ref.hideLabel;
  return hideLabel ? '0.5rem' : undefined;
}, function (_ref2) {
  var hideLabel = _ref2.hideLabel;
  return hideLabel ? '1rem' : undefined;
}, function (_ref3) {
  var hideLabel = _ref3.hideLabel;
  return hideLabel ? '1rem' : undefined;
});
var CheckboxContainer = /*#__PURE__*/memo(StyledLabel);

export default CheckboxContainer;
